import { render, staticRenderFns } from "./ActionButton.vue?vue&type=template&id=6ed6e8c6&scoped=true"
import script from "./ActionButton.vue?vue&type=script&lang=js"
export * from "./ActionButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed6e8c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ed6e8c6')) {
      api.createRecord('6ed6e8c6', component.options)
    } else {
      api.reload('6ed6e8c6', component.options)
    }
    module.hot.accept("./ActionButton.vue?vue&type=template&id=6ed6e8c6&scoped=true", function () {
      api.rerender('6ed6e8c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/base/ActionButton.vue"
export default component.exports